import React from 'react'
import TemporarySolutionView from './TemporarySolutionPage.view'

const TemporarySolutionPage: React.FC = () => (
  <div data-testid="not-found-page">
    <TemporarySolutionView />
  </div>
)

export default TemporarySolutionPage
